import type { GetMelodiesResponse, LastMelodyResponse } from './types';

const API_BASE_URL = import.meta.env.DEV 
  ? 'http://localhost:8787/api'
  : import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api';

export const api = {
  async getNextMelodies(count: number): Promise<GetMelodiesResponse> {
    const response = await fetch(`${API_BASE_URL}/melodies/next?count=${count}`);
    if (!response.ok) {
      throw new Error('Failed to fetch next melodies');
    }
    return response.json();
  },

  async markMelodyAsPlayed(index: number): Promise<void> {
    const response = await fetch(`${API_BASE_URL}/melodies/${index}/play`, {
      method: 'POST',
    });
    if (!response.ok) {
      throw new Error('Failed to mark melody as played');
    }
  },

  async getLastMelody(): Promise<LastMelodyResponse> {
    const response = await fetch(`${API_BASE_URL}/melodies/last`);
    if (!response.ok) {
      throw new Error('Failed to fetch last melody');
    }
    return response.json();
  }
}; 